import { Link } from '@/Framework/Router/Next/Link';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface IParentCompanyProps {
  deal: IDealHeader,
}

const ParentCompany = ({ deal }: IParentCompanyProps) => (
  deal?.parent?.viewId && (
    <div className={ styles.sponsorCol }>
      <Link
        className={ styles.link }
        to={ deal.parentLink }
        dataTest="dealRowParentLink"
      >
        { deal.parent.name }
      </Link>
    </div>
  )
);

export default ParentCompany;
